import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  type ExportDataModalContainerProps,
  ExportSpreadsheetDataContainer,
} from './exportSpreadsheetData.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ExportSpreadsheetData: ExportDataModalContainerProps;
  }
}
modalRenderer.register('ExportSpreadsheetData', ExportSpreadsheetDataContainer);
